// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ntable[data-v-3c9942dc] {\n  font-family: arial, sans-serif;\n  border-collapse: collapse;\n  width: 100%;\n  background: #ffffff;\n  color: rgba(0, 0, 0, 0.6);\n}\ntd[data-v-3c9942dc], th[data-v-3c9942dc] {\n  border: 1px solid #dddddd;\n  text-align: left;\n  padding: 8px;\n}\ntd[data-v-3c9942dc]{\n  color: #212529;\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
